import {booleanAttribute, ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule, MatMenuPanel} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {AuthUserNameComponent} from '../auth-user-name/auth-user-name.component';

@Component({
  selector: 'cmn-auth-user-chip',
  templateUrl: './auth-user-chip.component.html',
  styleUrl: './auth-user-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AuthUserNameComponent, MatIconModule, MatMenuModule, TranslateModule]
})
export class AuthUserChipComponent {

  /** Меню, которое открывает чип. Состав пунктов остаётся за порталом. */
  @Input() menu: MatMenuPanel;

  /** Имя рядом с аватаром; на узких экранах остаётся только аватар. */
  @Input({transform: booleanAttribute}) showName = true;
}
